import { SCREENS } from "utils/constants";
import List from "./List";
import Trace from "./Trace";

const routes = [
  {
    path: SCREENS.PRIVATE.ORGANIZATION.ORDINALS.LIST,
    exact: true,
    element: <List />,
  },
  {
    path: SCREENS.PRIVATE.ORGANIZATION.ORDINALS.TRACE.path,
    exact: true,
    element: <Trace />,
  },
];

export default routes;
